import { render, staticRenderFns } from "./InscricaoForm.vue?vue&type=template&id=33e0524e&scoped=true"
import script from "./InscricaoForm.vue?vue&type=script&lang=js"
export * from "./InscricaoForm.vue?vue&type=script&lang=js"
import style0 from "./InscricaoForm.vue?vue&type=style&index=0&id=33e0524e&prod&scoped=true&lang=css"
import style1 from "./InscricaoForm.vue?vue&type=style&index=1&id=33e0524e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e0524e",
  null
  
)

export default component.exports